/**
 * Edge Function URL helper.
 * All privileged Supabase operations run in Edge Functions in project mkethpwmkiwpgjkqdvgs.
 * Next.js API routes are thin proxies — they forward requests and handle HttpOnly cookies.
 * No SUPABASE_SERVICE_ROLE_KEY is needed in the Next.js / Netlify runtime.
 * deploy-marker: 2026-08-19T19:49:04Z — force fresh bundle with corrected SUPABASE_URL
 */

const SUPABASE_URL = process.env.NEXT_PUBLIC_SUPABASE_URL ?? '';

/**
 * Returns the base URL for Supabase Edge Functions.
 * e.g. https://mkethpwmkiwpgjkqdvgs.supabase.co/functions/v1
 */
export function edgeFunctionUrl(functionName: string): string {
  if (!SUPABASE_URL) {
    throw new Error('[edgeFunctionUrl] NEXT_PUBLIC_SUPABASE_URL is not set.');
  }
  return `${SUPABASE_URL}/functions/v1/${functionName}`;
}

/**
 * The anon key is safe to use in Next.js server routes as the Authorization header
 * when calling Edge Functions that only need to verify the user JWT.
 * The Edge Function itself uses the service-role key internally.
 */
export const SUPABASE_ANON_KEY = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY ?? '';
